import 'locale'

import { userLanguage, userPrivileges } from 'api/User/selectors'
import { connect } from 'react-redux'
import type { State } from 'store/types'

import App from './App'

const mapStateToProps = (state: State) => ({
  language: userLanguage(state),
  pathname: state.router && state.router.location && state.router.location.pathname,
  userPrivileges: userPrivileges(state),
})

export default connect(mapStateToProps)(App as any) as any
